// src/store/thunks/sixDetail/searchFilesThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { setSearchQuery } from '@/store/slices/sixDetail/sixDetailSlice';
import { fetchFilesThunk } from '@/store/thunks/sixDetail/fetchFilesThunk';
import { MIN_LEN } from '@/constants';

/**
 * Sets the search query in state and refetches files.
 * Debounce logic is handled by the container (not the thunk).
 */
export const searchFilesThunk = createAppAsyncThunk(
  'sixDetail/searchFiles',
  async(query: string, { dispatch, getState }) => {
    const trimmedQuery = query.trim();
    const searchValue = trimmedQuery.length > MIN_LEN ? trimmedQuery : undefined;

    dispatch(setSearchQuery(searchValue));

    const rootState = getState();
    const sixIdentifier = rootState.sixDetail.sixId;

    if (sixIdentifier !== undefined) {
      await dispatch(fetchFilesThunk({ sixId: sixIdentifier }));
    }
  }
);
